module.exports = __webpack_public_path__ + "static/media/heywow-semibold-webfont.083f493e.woff2";